var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInitiativeNpv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.5C1.5 1.08516 1.16484 0.75 0.75 0.75C0.335156 0.75 0 1.08516 0 1.5V9.375C0 10.4109 0.839062 11.25 1.875 11.25H11.25C11.6648 11.25 12 10.9148 12 10.5C12 10.0852 11.6648 9.75 11.25 9.75H1.875C1.66875 9.75 1.5 9.58125 1.5 9.375V1.5V1.5M11.0297 3.52969C11.3227 3.23672 11.3227 2.76094 11.0297 2.46797C10.7367 2.175 10.2609 2.175 9.96797 2.46797L7.5 4.93828L6.15469 3.59297C5.86172 3.3 5.38594 3.3 5.09297 3.59297L2.46797 6.21797C2.175 6.51094 2.175 6.98672 2.46797 7.27969C2.76094 7.57266 3.23672 7.57266 3.52969 7.27969L5.625 5.18672L6.97031 6.53203C7.26328 6.825 7.73906 6.825 8.03203 6.53203L11.032 3.53203L11.0297 3.52969",
    fill: "#1A4252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiativeNpv);
export default __webpack_public_path__ + "static/media/initiative-npv.5a374da5def862f385085371e240e707.svg";
export { ForwardRef as ReactComponent };